import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClientService } from '../../shared/services/http-client/http-client.service';
import {
  CampanhaIntegracoesQueryParams,
  CampanhaIntegracoesResponseDto,
  CampanhaLogIntegracaoResponseDto,
} from '../api/models';

const CAMPANHA_BASE_PATH = '/v1/Campanha';

@Injectable({
  providedIn: 'root',
})
export class IntegracaoApiService {
  constructor(private readonly httpClient: HttpClientService) {}

  /**
   * Participantes da campanha na integração, com o resumo da carga na mesma resposta. Substituiu
   * os antigos `/v1/Integracao/{id}/Adesoes` e `/v1/Integracao/{id}/Log`, que nunca existiram.
   */
  getIntegracoesDaCampanha(
    idCampanha: number | string,
    params?: CampanhaIntegracoesQueryParams,
  ): Observable<CampanhaIntegracoesResponseDto> {
    return this.httpClient.get<CampanhaIntegracoesResponseDto>(
      `${CAMPANHA_BASE_PATH}/${idCampanha}/Integracoes`,
      { params: this.toHttpParams(params) },
    );
  }

  /**
   * Integra um participante específico da campanha. `idPerfInvestPartic` é quem garante o
   * escopo — toda linha da grade tem um, então a chamada nunca sai sem filtro (o que integraria a
   * campanha inteira). `codCltrprf` vai também quando a linha tiver, espelhando exatamente os
   * parâmetros que o back repassa pra procedure.
   */
  integrarPerfisParticipantes(
    idCampanha: number | string,
    idPerfInvestPartic: number,
    codCltrprf?: number | null,
  ): Observable<void> {
    let params = new HttpParams().set('idPerfInvestPartic', idPerfInvestPartic);
    if (codCltrprf != null) {
      params = params.set('codCltrprf', codCltrprf);
    }

    return this.httpClient.post<void>(
      `${CAMPANHA_BASE_PATH}/${idCampanha}/IntegrarPerfisParticipantes`,
      {},
      { params },
    );
  }

  /**
   * Histórico de um participante: o que aconteceu com a adesão dele na integração. A chave é
   * `idPerfInvestPartic`, não o id da adesão usado na seleção.
   */
  getLogDoParticipante(
    idCampanha: number | string,
    idPerfInvestPartic: number | string,
  ): Observable<CampanhaLogIntegracaoResponseDto[]> {
    return this.httpClient.get<CampanhaLogIntegracaoResponseDto[]>(
      `${CAMPANHA_BASE_PATH}/${idCampanha}/LogIntegracoes/${idPerfInvestPartic}`,
    );
  }

  /** Todos os parâmetros são opcionais: os vazios ficam fora da URL. */
  private toHttpParams(params?: CampanhaIntegracoesQueryParams): HttpParams | undefined {
    if (!params) {
      return undefined;
    }

    let httpParams = new HttpParams();

    for (const [chave, valor] of Object.entries(params)) {
      if (valor) {
        httpParams = httpParams.set(chave, valor);
      }
    }

    return httpParams.keys().length > 0 ? httpParams : undefined;
  }
}
